import * as types from 'reducer/actionTypes'
import { isEmpty } from 'script/common';

const initialState = {
	licenseType: {
		"0": "Trial",
		"1": "Normal",
		"2": "Evaluation",
		"3": "Demo",
		"-1": "Unknown"
	},
	licenseInfo: {
		type: null,
		key: null,
		issuedOn: null,
		expiresOn: null,
		days: 0,
		spents: 0,
		checkParams: null,
		publisher: null,
		lastAuthDate: null,
		company: null,
		status: null
	},

	// modal창
	licenseUpdate: {
		modalVisible: false,
		errorLabel: null
	},

	exportData: {
		value: null,
		error: null
	},
	licenseStats: {
		constrainValue: 0,
		currentCoConnection: 0,
		availableCoConnection: 0
	},
	manualAuth: {
		loading: false,
		success: false,
		error: null,
		lastAuthTime: null,
		lastAuthDate: null
	},
	error: null
};

export default function license(state = initialState, action) {
	switch (action.type) {

		case types.SET_LICENSE_UPDATE_MODAL:
			return {
				...state,
				licenseUpdate: {
					modalVisible: !state.licenseUpdate.modalVisible,
					errorLabel: initialState.licenseUpdate.errorLabel
				}
			}

		case types.SET_LICENSE_UPDATE_ERRORLABEL:
			return {
				...state,
				licenseUpdate: {
					...state.licenseUpdate,
					errorLabel: action.errorLabel
				}
			}
		case types.FETCH_EXPORT_DATA_REQUEST:
			return {
				...state,
				exportData: {
					loading: true,
					error: null,
				}
			};

		// fetch success
		case types.FETCH_GET_LICENSE_INFO_SUCCESS:
			return {
				...state,
				licenseInfo: isEmpty(action.value) ? initialState.licenseInfo : action.value,
				licenseStats: isEmpty(action.value) ? initialState.licenseStats : action.value,
				error: initialState.error
			}

		case types.FETCH_SET_LICENSE_UPDATE_SUCCESS:
			return {
				...state,
				loading: false,
				error: initialState.error
			}

		case types.FETCH_EXPORT_DATA_SUCCESS:
			return {
				...state,
				exportData: {
					value: action.value,
					error: initialState.error
				}
			};

		// fetch failure
		case types.FETCH_GET_LICENSE_INFO_FAILURE:
			return {
				...state,
				licenseInfo: initialState.licenseInfo,
				error: action.error
			}

		case types.FETCH_SET_LICENSE_UPDATE_FAILURE:
			return {
				...state,
				error: action.error
			}

		case types.FETCH_EXPORT_DATA_FAILURE:
			return {
				...state,
				exportData: {
					loading: false,
					value: null,
					error: action.error
				}
			};

		// Manual Auth
		case types.FETCH_MANUAL_AUTH_REQUEST:
			return {
				...state,
				manualAuth: {
					loading: true,
					success: false,
					error: null
				}
			};

		case types.FETCH_MANUAL_AUTH_SUCCESS:
			return {
				...state,
				manualAuth: {
					loading: false,
					success: true,
					error: null
				}
			};

		case types.FETCH_MANUAL_AUTH_FAILURE:
			return {
				...state,
				manualAuth: {
					loading: false,
					success: false,
					error: action.error
				}
			};

		case types.SET_LAST_AUTH_TIME:
			console.log('SET_LAST_AUTH_TIME action:', action);
			return {
				...state,
				manualAuth: {
					...state.manualAuth,
					lastAuthTime: action.lastAuthTime,
					lastAuthDate: action.lastAuthDate
				},
				licenseInfo: {
					...state.licenseInfo,
					lastAuthDate: action.lastAuthDate
				}
			};

		default:
			return state
	}
}